<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-link icon"></i>
        Links gerados
      </h1>
    </div>
  </div>

  <div class="align p-4 space_title">
    <div v-if="!loading || articlesLinks.data" class="card">
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Título</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, key) in articlesLinks.data" :key="key">
            <td>
              {{ article.title }}
            </td>
            <td>
              {{ $dateFormat(article.updated_at) }}
            </td>
          </tr>

          <tr class="no_result" v-if="!articlesLinks || (articlesLinks.data && !articlesLinks.data.length)">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <ListPagination class="mt-4" :links="articlesLinks.meta.links" />

  </div>
</template>
  
<script setup>
import { onBeforeMount, ref, watch } from 'vue';
import { useArticleStore } from '@/stores/ArticleStore'
import { storeToRefs } from 'pinia';
import { useRoute } from 'vue-router';
import ListPagination from '@/components/ListPagination.vue'

import { inject } from 'vue';
import axios from "axios";
const loader = inject('$loader');
const loading = ref(true);
let cancelTokenSource = null;
const articleStore = useArticleStore();
const { filter, articlesLinks } = storeToRefs(articleStore);

const route = useRoute();

onBeforeMount(() => {
  loadArticlesLinks();
});

watch(() => route.query.page, () => {
  window.scrollTo(0, 0);
  loadArticlesLinks();
});


async function loadArticlesLinks() {
  loader.show();
  loading.value = true;

  filter.value.page = route.query.page ? parseInt(route.query.page) : null;

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  cancelTokenSource = axios.CancelToken.source();

  await articleStore.getArticlesLinks(cancelTokenSource);

  loader.hide();
  loading.value = false;
}
</script>